import { useMemo } from 'react'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import { useApplicationSettings } from 'hooks/usePageConfig'
import {
  generateIncludedDomainsNameStrategy,
  generateRedditIncludedDomainsNameStrategy
} from 'utils/insightModal/strategy/widgetSettingComposing'

const useWidgetSettingComposingStrategy = (viewOption: InsightViewOptionStrings) => {
  const applicationSettings = useApplicationSettings()
  const widgetSettingComposingStrategy = useMemo(() => {
    switch (viewOption) {
      case InsightViewOption.ALL_SOURCES:
      case InsightViewOption.BLOGS:
      case InsightViewOption.FORUMS:
      case InsightViewOption.NEWS:
        return generateIncludedDomainsNameStrategy(applicationSettings)
      case InsightViewOption.SUBREDDITS:
        return generateRedditIncludedDomainsNameStrategy(applicationSettings)
      default:
        throw new Error(`Unsupported view option: ${viewOption}`)
    }
  }, [viewOption, applicationSettings])

  return widgetSettingComposingStrategy
}

export default useWidgetSettingComposingStrategy
